module.exports = __webpack_public_path__ + "img/circle-arrow-filled.26e12859.svg";